/**
 * @file AllUsersSkeleton.tsx
 * @description
 * -----------------------------------------------------
 * Componente para la pagina de all users de super admin
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-04-09
 * @author DLTCode
 * @license Private
 * */
"use client";

import { c as _c } from "react/compiler-runtime";
import TableSkeleton from "@/components/ui/skeletons/TableSkeleton";
import PaginationSkeleton from "@/components/ui/skeletons/PaginationSkeleton";
import FiltersSkeleton from "@/components/ui/skeletons/FiltersSkeleton";
export default function UsersSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="skeleton"><FiltersSkeleton /><TableSkeleton /><PaginationSkeleton /></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}